import React, { useState, useContext } from 'react';
import OfficeHour from '../models/OfficeHour'
import { ProductsContext } from './Products'
import { useFetch, Items } from '@thinkwell/react.common'
import { ShopContext } from './Shop'

const OfficeHoursContext = React.createContext([[], () => {}, {}, () => {}, () => {}, () => {}]);

const OfficeHoursProvider = (props) => {
  const [products] = useContext(ProductsContext)

  const officeHours = (props.value || []).map((c) => OfficeHour(c, products))
  const [items, setItems, upsertItem, getItem, deleteItem] = Items(useState(officeHours))

  const setOfficeHours = (items) => {
    const officeHours = items.map((i) => OfficeHour(i, products))
    setItems(officeHours)
  }
  const [fetchOfficeHoursState, fetchOfficeHours] = useFetch({onSuccess: setOfficeHours})

  const upsertOfficeHour = (item) => {
    upsertItem(OfficeHour(item, products))
  }

  return (
    <OfficeHoursContext.Provider value={[items, fetchOfficeHours, fetchOfficeHoursState, upsertOfficeHour, getItem, deleteItem]}>
      {props.children}
    </OfficeHoursContext.Provider>
  );
};

export { OfficeHoursContext, OfficeHoursProvider}
